// extracted by mini-css-extract-plugin
export default {"note":"ZmqA_","icon":"_YUKA"};